import { assert } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../../base';
import { CollectionLoader } from './collectionInterface';
import { CollectionAggregate } from './collectionModel';

export function createCollectionLoader(
    config: ReportingLoaderBaseConfig
): CollectionLoader {
    const {
        repository: { research },
    } = config;

    return {
        useLoad(context, props): CollectionAggregate {
            const countQuery = research.count.useLookup(
                context,
                {
                    kind: 'collection.total',
                    scope: props.collection,
                },
                {
                    staleTime: Infinity,
                    refetchOnWindowFocus: true,
                    suspense: true,
                }
            );

            const collectionQuery = research.collection.useLookup(
                context,
                {
                    collectionId: props.collection,
                },
                {
                    staleTime: Infinity,
                    suspense: true,
                }
            );

            const recordQuery = research.record.useFind(
                context,
                {
                    collection: props.collection,
                },
                {
                    // keepPreviousData: true,
                    staleTime: Infinity,
                    suspense: true,
                }
            );

            assert(collectionQuery.status === 'success', 'expected suspense');
            assert(recordQuery.status === 'success', 'expected suspense');
            assert(countQuery.status === 'success', 'expected suspense');

            return {
                collection: collectionQuery.data,
                count: countQuery.data,
                record: {
                    query: recordQuery,
                    items: recordQuery.data,
                },
            };
        },
    };
}
